import { render, staticRenderFns } from "./SignupSuccess.vue?vue&type=template&id=8b48503c&scoped=true&"
var script = {}
import style0 from "./SignupSuccess.vue?vue&type=style&index=0&id=8b48503c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b48503c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
